import { Reducer } from 'redux';
import { PlanActions, PlansState } from '../types';
import { getFailureTypeOf, getStartTypeOf, getSuccessTypeOf } from '../utils/redux';

const initialState = {
  error: null,
  fetchingPlans: false,
  fetchPlanError: false,
  loading: false,
  basicPlanModalOpen: false,
  basicPlanModalPlanType: "",
  selectedPlanType: null,
  planOptionsOpen: false,
  errorModalOpen: false,
  selectedPlan: null,
  downloadingPlan: false,
  plans: [],
}

const reducer: Reducer<PlansState> = (state = initialState, action) => {
  switch (action.type) {
    case PlanActions.SET_BASIC_PLAN_MODAL:
      return {
        ...state,
        basicPlanModalOpen: action.payload.modal_open,
        basicPlanModalPlanType: action.payload.plan_type ? action.payload.plan_type : null
      };
    case PlanActions.SET_ERROR_DETAILS_MODAL:
      return {
        ...state,
        errorModalOpen: action.payload.open,
        selectedPlan: action.payload.planId 
          ? 
          state.plans.find(plan => plan.id === action.payload.planId) 
          :
           null,
      };
    case PlanActions.SET_PLAN_TYPE:
      return {
        ...state,
        selectedPlanType: action.payload,
      };
    case PlanActions.SET_PLAN_OPTIONS:
      return {
        ...state,
        planOptionsOpen: action.payload,
      };
    case getFailureTypeOf(PlanActions.FETCH_PLANS):
      return {
        ...state,
        fetchPlanError: true,
        fetchingPlans: false,
      };
    case getStartTypeOf(PlanActions.FETCH_PLANS):
      return {
        ...state,
        fetchPlanError: false,
        fetchingPlans: true,
      };
    case getSuccessTypeOf(PlanActions.FETCH_PLANS):
      console.log(action.payload);
      return {
        ...state,
        plans: action.payload
      };
    default:
      return state;
  }
};

export default reducer;